export enum ActionType {
  Open = 'feature/vehicleItemOverlay/OPEN_OVERLAY',
  Close = 'feature/vehicleItemOverlay/CLOSE_OVERLAY',
}
